var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_319_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9302 47.0927L41.4754 27.4133C50.8774 14.6926 55.5784 8.33219 59.9643 9.67628C64.3503 11.0204 64.3503 18.8213 64.3503 34.4233V35.8944C64.3503 41.5217 64.3503 44.3354 66.1483 46.1002L66.2435 46.1917C68.0804 47.9192 71.0088 47.9192 76.8656 47.9192C87.4053 47.9192 92.6751 47.9192 94.4561 51.1157C94.4856 51.1686 94.5143 51.222 94.5421 51.2757C96.2234 54.5217 93.1721 58.65 87.0696 66.9065L72.5244 86.5856C63.1223 99.3065 58.4212 105.667 54.0352 104.323C49.6493 102.979 49.6494 95.1775 49.6496 79.5754L49.6496 78.105C49.6497 72.4776 49.6498 69.6639 47.8517 67.899L47.7566 67.8076C45.9197 66.0799 42.9912 66.0799 37.1343 66.0799C26.5947 66.0799 21.3249 66.0799 19.5439 62.8835C19.5144 62.8305 19.4857 62.7772 19.4579 62.7235C17.7766 59.4775 20.8278 55.3493 26.9302 47.0927Z",
    fill: "url(#paint0_linear_319_251)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_319_251",
    x: 0,
    y: -3.00049,
    width: 114,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_319_251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_251",
    x1: 22.4358,
    y1: 23.229,
    x2: 103.857,
    y2: 33.3665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.589d763129a140e96d06608ed1d6f6f4.svg";
export { ForwardRef as ReactComponent };